import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
// Helpers
import { createBrowserHistory } from "history";

// Store
import configureStore from "./configureStore";

// Components
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Styles
import './assets/scss/application.scss';
if (typeof fetch === 'undefined') {
  global.fetch = require('node-fetch');
}


const customHistory = createBrowserHistory();
const store = configureStore();

ReactDOM.render(
  <Provider history={customHistory} store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById("root"),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
